import "../scss/style.scss";
import Swiper from 'swiper';
import 'swiper/css';
import {Navigation, Pagination} from 'swiper/modules';
import * as translations from "./translations"


console.log(translations.lang)


// Scrollspy
// Elementy linków nawigacyjnych
const links = document.querySelectorAll(".nav-link");

const mobileNav = document.querySelector('.navbar-collapse')
links.forEach(item => {
    item.addEventListener('click', () => {

        mobileNav.classList.remove('show');

    })
})


// Funkcja, która usuwa klasę 'active' ze wszystkich linków
function removeActiveClasses() {
    links.forEach((link) => {
        link.classList.remove("active");
    });
}

const navbar = document.querySelector("nav");


// Funkcja obsługująca zmianę aktywnego linku nawigacyjnego
function handleScrollSpy() {
    let index = sections.length;
    // Przechodzenie przez wszystkie sekcje w celu ustalenia, która jest widoczna
    while (--index && window.scrollY + 155 < sections[index].offsetTop) {
    }

    // Usuwanie 'active' z poprzednich linków i ustawienie na aktualnym
    if (index == 1 || index == 2 || index == 4 || index == 5) {
        navbar.classList.add("section-inverted");
    } else {
        navbar.classList.remove("section-inverted");
    }
    if (index > 0 && index < 3) {
        removeActiveClasses()
        links[index - 1].classList.add("active");
    }

    if (index == 0) {
        removeActiveClasses()
    }
    if (index >= 3) {
        removeActiveClasses()
        links[index - 2].classList.add("active");
    }
}

// Tablica z sekcjami
const sections = document.querySelectorAll(".app-section");

// Nasłuchiwanie przewijania strony
window.addEventListener("scroll", handleScrollSpy);

// Inicjalne wywołanie
handleScrollSpy();

/*
  GALLERY
*/
document.querySelectorAll(".gallery");
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    // addAnimation();
}


let listeners = []
const addAnim = (target, direction, speed) => {
    let visibleArea = window.innerWidth;
    let gallery = document.querySelector(target);
    let width = gallery.scrollWidth / 2;
    let walk = (width - visibleArea) + visibleArea;
    gallery.style.transitionDuration = '0s';
    gallery.style.transform = direction === 'left' ? `translateX(0)` : `translateX(${-walk}px)`;
    gallery.offsetWidth
    gallery.style.transitionTimingFunction = 'linear';
    gallery.style.transitionDuration = `${speed}s`;
    gallery.style.transform = `translateX(${direction === 'left' ? -walk : 0}px)`;


    // listeners.push({element: gallery, event: 'transitionend'})

    function endHandler() {

        gallery.style.transitionDuration = '0s';
        gallery.style.transform = direction === 'left' ? `translateX(0)` : `translateX(${-walk}px)`;
        setTimeout(() => {
            setT(gallery, speed, walk, direction);
        }, 0);
    }

    gallery.addEventListener('transitionend', endHandler);

    listeners.push({
        element: gallery,
        event: 'transitionend',
        handler: endHandler
    });


}


setTimeout(() => {
    addAnim('.gallery-slide.one', 'left', 66);
    addAnim('.gallery-slide.two', 'left', 64);

    addAnim('.gallery-slide.three', 'right', 68);


}, 400)

function setT(gallery, speed, walk, direction) {

    gallery.style.transitionDuration = `${speed}s`;
    gallery.style.transform = `translateX(${direction === 'left' ? -walk : 0}px)`;
}

let resizeTimeout;
let innerWidth;

window.addEventListener('resize', () => {

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        if (innerWidth !== window.innerWidth) {
            innerWidth = window.innerWidth;
            console.log('zmiana szerokosci ');
            listeners.forEach(item => {
                item.element.removeEventListener(item.event, item.handler);
            })

            addAnim('.gallery-slide.one', 'left', 66);
            addAnim('.gallery-slide.three', 'right', 68);
            addAnim('.gallery-slide.two', 'left', 64);
            // addAnim('.gallery-slide.three', 'left', 6);
        }
    }, 100);
})


let active_slide = 4


let bullets = document.querySelectorAll('#bullet')

const removeActiveBullets = () => {
    bullets.forEach(item => item.classList.remove('active'))
}

const setActiveBullets = (index) => {

    while (index > 0) {
        bullets.forEach(item => {

            let id = item.getAttribute('data-id');
            if (parseInt(id) == index) {
                item.classList.add('active')
            }
        })
        index--
    }
}


const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    direction: "horizontal",
    loop: false,
    slidesPerView: 1,
    grabCursor: true,
    // spaceBetween: 10,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,

    pagination: {
        el: ".swiper-pagination"
    },
    breakpoints: {
        500: {
            // spaceBetween: 0,
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
        },
        800: {
            // spaceBetween: 0,
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
        },
        1200: {
            slidesPerView: 1,
            spaceBetween: -1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
        }
    }
});


swiper.on('activeIndexChange', function (e) {
    removeActiveBullets();
    active_slide = e.activeIndex + 1;
    setActiveBullets(active_slide);

});


const clubs = document.querySelector('.clubs');
clubs.addEventListener('click', () => [
    clubs.classList.toggle('active')
])


const clubsToHover = document.querySelectorAll('.clubs p');
const clubsContainer = document.querySelector('.clubs')
const markers = document.querySelectorAll('.marker');


clubsToHover.forEach(val => {
    val.addEventListener('mouseenter', (e) => {
        if (!clubsContainer.classList.contains('active')) {
            return
        }
        let item = e.currentTarget;


        markers.forEach(marker => {
            if (marker.getAttribute('data-name') === item.getAttribute('data-name')) {
                updateBoxPosition(marker);
                box.style.display = "block";
                box.textContent = marker.dataset.address;
                marker.classList.add('clicked');
            }
        })
    })
})

clubsToHover.forEach(val => {
    val.addEventListener('mouseleave', () => {
        markers.forEach(marker => {
            marker.classList.remove('clicked');
            box.style.display = "none";
        })
    })
})


const box = document.getElementById("info-box");

function updateBoxPosition(group) {
    const container = document.getElementById("Map_div");
    const containerRect = container.getBoundingClientRect();
    const svgRect = group.getBoundingClientRect();
    const x = svgRect.left - containerRect.left;
    const y = svgRect.top - containerRect.top;
    box.style.left = `${x + svgRect.width + 10}px`;
    box.style.top = `${y + svgRect.height / 2 - 10}px`;
}


